<div class="flex flex-col gap-3 mt-2">
  <div class="soft-card flex flex-col py-2">
    <p class="font-semibold">{{ bewe().lfdnr | number: '3.0' }}</p>
    <p class="font-semibold text-base">{{ bewe().artikelMenge.artikel.artbez1 ?? 'Artikel' }}</p>
  </div>

  <div class="flex flex-col divide-y px-2" data-testid="pallet-summary-list">
    @for (pallet of pallets(); track $index) {
      <div class="flex flex-col gap-0.5 py-2" data-testid="pallet-summary-row">
        <div class="flex justify-between">
          <span class="font-semibold">
            {{ '#WWS_WARENUEBERNAHME.DIALOG.PALLET_DETAIL.PALETTE' | translate }}
            {{ $index + 1 | number: '2.0-0' }}
          </span>
          <span>{{ pallet.menge ?? 0 | number: '1.0-9' }} {{ unit() }}</span>
        </div>
        <span class="text-sm text-light">
          {{ '#WWS_WARENUEBERNAHME.DIALOG.PALLET_DETAIL.SSCC' | translate }}:
          {{ pallet.sscc || '–' }}
        </span>
        <span class="text-sm text-light">
          {{ '#WWS_WARENUEBERNAHME.DIALOG.PALLET_DETAIL.CHARGENNUMMER' | translate }}:
          {{ pallet.chargennummer || '–' }}
        </span>
      </div>
    }
  </div>

  @if (difference() !== 0) {
    <div
      class="flex items-center gap-3 py-1.5 px-2.5 rounded border border-danger-600 bg-danger-50"
      data-testid="pallet-summary-difference"
    >
      <soft-ds-icon name="fa-solid fa-triangle-exclamation" class="text-danger-600 text-xl" />
      <span class="text-danger-600 text-sm font-semibold">
        {{ '#WWS_WARENUEBERNAHME.DIALOG.PALLET_SUMMARY.DIFFERENZ' | translate }}
        {{ difference() | number: '1.0-9' }} {{ unit() }}
      </span>
    </div>
  }

  <div class="flex gap-3 w-full">
    <button
      class="soft-button outline rounded-sm h-16 w-full"
      (click)="resolve(false)"
    >
      {{ '#WWS_WARENUEBERNAHME.DIALOG.LABEL_ABBRECHEN' | translate }}
    </button>
    <button
      class="soft-button primary rounded-sm h-16 w-full"
      [disabled]="difference() !== 0"
      (click)="resolve(true)"
    >
      {{ '#WWS_WARENUEBERNAHME.DIALOG.TITEL_POSITION_ERLEDIGT_MARKIEREN' | translate }}
    </button>
  </div>
</div>
